export default __webpack_public_path__ + "static/media/cross.cebe98e5.png";